export const generatedTestCaseTable = [
  {
    key : "row-select",
    display_name : "",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    cellStyles: {
      width: 0,
    },
    headerStyles: {
      background : "#7593F2",
      color: "#FFFFFF",
      width : "4%",
      "font-weight": 600
    }
  },
  {
    display_name: "Story ID",
    key: "key",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "8%",
      "font-weight": 600,
    },
  },
  {
    display_name: "Story",
    key: "storydesc",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "12%",
    },
  },
  {
    display_name: "TC ID",
    key: "testCaseId",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "5%",
      "font-weight": 600,
    },
  },
  {
    display_name: "TC Description",
    key: "testCase",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "12%",
    },
  },
  {
    display_name: "Prerequisites",
    key: "prerequisites",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "15%",
    },
  },
  {
    display_name: "Test Steps",
    key: "testScenario",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "17%",
    },
  },
  {
    display_name: "Expected Results",
    key: "expectedResult",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "15%",
    },
  },
  {
    display_name: "Feedback",
    key: "feedback",
    _config: {
      isClickable: true,
      displayInColumn: false,
      type: "thumb-feedback",
      value: ["thumb_up", "thumb_down"],
      iconStyles: {
        color: "#bdcdff",
        "font-size": "14px",
      },
      placeholder: "Give feedback...",
      classNames: "height-5rem",
    },
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "10%",
    },
  },
];
